import React, { useState } from 'react'
import { Globe } from 'lucide-react'

interface SessionFormProps {
  languages: string[]
  onSubmit: (ownerLanguage: string, guestLanguage: string) => void
  isLoading: boolean
}

export const SessionForm: React.FC<SessionFormProps> = ({ 
  languages, 
  onSubmit, 
  isLoading 
}) => {
  const [ownerLanguage, setOwnerLanguage] = useState('English')
  const [guestLanguage, setGuestLanguage] = useState('Urdu')

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (ownerLanguage && guestLanguage && ownerLanguage !== guestLanguage) {
      onSubmit(ownerLanguage, guestLanguage)
    }
  }

  return (
    <div className="card max-w-md mx-auto">
      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="text-center mb-6">
          <div className="flex justify-center mb-4">
            <div className="w-12 h-12 bg-primary-100 rounded-lg flex items-center justify-center">
              <Globe className="w-6 h-6 text-primary-600" />
            </div>
          </div>
          <h3 className="text-lg font-semibold text-gray-900">
            Choose Languages
          </h3>
          <p className="text-sm text-gray-600 mt-1">
            Select the languages for your translation session
          </p>
        </div>

        <div className="space-y-4">
          <div>
            <label htmlFor="owner-language" className="block text-sm font-medium text-gray-700 mb-2">
              Your Language
            </label>
            <select
              id="owner-language"
              value={ownerLanguage}
              onChange={(e) => setOwnerLanguage(e.target.value)}
              className="input-field"
              required
            >
              {languages.map((language) => (
                <option key={language} value={language}>
                  {language}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label htmlFor="guest-language" className="block text-sm font-medium text-gray-700 mb-2">
              Guest Language
            </label>
            <select
              id="guest-language"
              value={guestLanguage}
              onChange={(e) => setGuestLanguage(e.target.value)}
              className="input-field"
              required
            >
              {languages.map((language) => (
                <option key={language} value={language}>
                  {language}
                </option>
              ))}
            </select>
          </div>
        </div>

        {ownerLanguage === guestLanguage && (
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3">
            <p className="text-sm text-yellow-800">
              Please select different languages for translation.
            </p>
          </div>
        )}

        <button
          type="submit"
          disabled={isLoading || ownerLanguage === guestLanguage}
          className="btn-primary w-full disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isLoading ? 'Creating Session...' : 'Create Session'}
        </button>
      </form>
    </div>
  )
} 